export class Configuration {
  constructor(private readonly path: string) {}

  static Configuration() {
    return new Configuration("/configuration");
  }

  getClientSchemaUrl(): string {
    return `${this.path}/schemas/data/latest`;
  }

  putClientSchemaUrl(): string {
    return `${this.path}/schemas/data`;
  }

  getUISchemaUrl(): string {
    return `${this.path}/schemas/ui/latest`;
  }

  putUISchemaUrl(): string {
    return `${this.path}/schemas/ui`;
  }

  getConfigurableListsUrl(): string {
    return `${this.path}/schemas/conflists/latest`;
  }
  putConfigurableListsUrl(): string {
    return `${this.path}/schemas/conflists`;
  }
}
